var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [
        _vm._v("\n\t\t" + _vm._s(_vm.t("health", "Sleep", {})) + "\n\t")
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.t("health", "Chart", {})))]),
      _vm._v(" "),
      !_vm.loading
        ? _c("SleepChart", {
            attrs: { person: _vm.person, data: _vm.sleepData }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e(),
      _vm._v(" "),
      _c("h3", [_vm._v("Data")]),
      _vm._v(" "),
      !_vm.loading
        ? _c("SleepTable", {
            attrs: { data: _vm.sleepData, person: _vm.person }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("div", { staticClass: "icon-loading" }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }